import { Translation, Translator } from '@morningtrain/react-translations'
import { ExecuteOperationOnPipe, useValue } from '@morningtrain/react-resources'
import Smartview from 'widgets/smartviews/Smartview'
import { SubmitButton } from 'ui/buttons'
import { Pipeline, TriggerPipelineOnClick, useEnvValue } from '@morningtrain/react-helpers'
import React from 'react'
import * as UI from 'ui'
import { ButtonWrap } from 'ui'
import { ResourceSelector } from 'support/fields'
import * as Displays from 'support/displays'
import { Env } from '@morningtrain/helpers'
import SmartviewContentSection from 'widgets/smartviews/partials/SmartviewContentSection'

export function OnboardingTemplateSmartview () {
  const id = useValue('id')

  const [, setSelectedUser] = useEnvValue('onboarding.assign_user.user_id', null)
  const [, setListId] = useEnvValue('onboarding.assign_user.list_id', id)

  setListId(id)

  return (
    <Smartview header={<Displays.Text name='name' />}>
      <Translator namespace='smartviews.onboarding'>

        <SmartviewContentSection>
          <UI.Text size='md'>
            <Translation name='assign_onboarding_to_user' />
          </UI.Text>

          <ResourceSelector
            onChange={(userId) => setSelectedUser(userId)}
            name='user_id'
            optionsKey='name'
            resourceName='users.users'
            label={<Translation name='user' />}
            operationName='select'
          />

          <ButtonWrap>
            <Pipeline>
              <TriggerPipelineOnClick>
                <SubmitButton>
                  <Translation name='assign_checklist' />
                </SubmitButton>
              </TriggerPipelineOnClick>
              <ExecuteOperationOnPipe
                namespace='api'
                resourceName='onboarding.onboarding_checklists'
                operationName='assign_onboarding'
                data={() => {
                  return {
                    checklist_id: Env.get('onboarding.assign_user.list_id'),
                    user_id: Env.get('onboarding.assign_user.user_id')
                  }
                }}
              />
              <ExecuteOperationOnPipe
                namespace='api'
                resourceName='onboarding.onboarding_checklists'
                operationName='index'
              />
            </Pipeline>
          </ButtonWrap>
        </SmartviewContentSection>
      </Translator>
    </Smartview>
  )
}
